import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import FieldList from './FieldList'

class Summary extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        fields: PropTypes.object,
    }

    render()
    {
        return (
            <FieldList fields={this.props.fields} />
        )
    }
}

export default withTranslation()(Summary)
